import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const styles = theme => ({
  notchedOutline: {
    borderWidth: '2px',
    borderColor: '#03A9F4',
  },
  focused: {
    '& notchedOutline': {
      borderColor: '#03A9F4',
    }
  }
});

class OutlinedTextFields extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <TextField
        {...this.props}
        InputProps={{
          classes: {
            notchedOutline: classes.notchedOutline,
          },
          style: {
            backgroundColor: 'transparent',
          }
        }}
      />
    );
  }
}

OutlinedTextFields.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(OutlinedTextFields);
